export enum RoleEnum {
  SuperAdmin = 1,
  Admin = 2,
  Analytics = 3,
  TenantAssociate = 4,
  TenantManager = 5,
  ContentManager = 6,
}

export enum AppPlatformEnum {
  Android = 1,
  IOS = 2,
}

export enum GenderEnum {
  Male = 1,
  Female = 2,
  Other = 3,
}

export enum WorkingHoursEnum {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}

export enum DealTypeEnum {
  Voucher = 1,
  EventTicket = 2,
}

export enum CustomerGroupStatusEnum {
  Processing = 1,
  Completed = 2,
  Failed = 3,
  Created = 4,
}

export enum ReferralStatusEnum {
  Pending = 1,
  Active = 2,
  Completed = 3,
}

export enum StaticCampaignTypeEnum {
  None = 0,
  WelcomeBonus = 1,
  BirthdayReward = 2,
  AnniversaryBonus = 3,
  Referral = 4,
}

export enum CampaignTriggerTypeEnum {
  None = 0,
  PerTransaction = 1,
  OnGoalReached = 2,
  OnStreak = 3,
}

export enum LoyaltyTierTypeEnum {
  Classic = 1,
  Silver = 2,
  Gold = 3,
  Platinum = 4,
}

export enum RewardCalculationTypeEnum {
  FixedAmount = 1,
  Multiplier = 2,
}

export enum VenueTypeEnum {
  Hotel = 1,
  Restaurant = 2,
  Spa = 3,
  Other = 4,
}
